import {
    ASSIGNMENT__MEMBERSHIPS__REQUESTED__SUCCEEDED,
    DROPBOX__USER__MEMBERSHIPS__REQUESTED__SUCCEEDED, SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED,
    SUBMISSION__MEMBERSHIP__DELETE__REQUESTED,
    SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__SUCCEEDED,
    SUBMISSION__MEMBERSHIPS__REQUESTED__SUCCEEDED
} from "../constants/actionTypes";
import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function memberships(state = INITIAL_STATE, action) {
    switch (action.type) {

        case DROPBOX__USER__MEMBERSHIPS__REQUESTED__SUCCEEDED: {
            const { dropbox, memberships, user } = action.payload;

            return {
                ..._.mapKeys(memberships.entities, id),
                dropbox,
                user,
            };
        }

        case ASSIGNMENT__MEMBERSHIPS__REQUESTED__SUCCEEDED: {
            const { assignment, memberships } = action.payload;

            return {
                ..._.mapKeys(memberships.entities, id),
                assignment,
            };
        }

        case SUBMISSION__MEMBERSHIPS__REQUESTED__SUCCEEDED: {
            const { memberships, submission } = action.payload;

            return {
                ..._.mapKeys(memberships.entities, id),
                submission,
            };
        }

        case SUBMISSION__MEMBERSHIP__DELETE__REQUESTED: {
            return {
                ...action.payload.submission,
            };
        }

        case SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__SUCCEEDED: {
            return INITIAL_STATE;
        }

        case SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED: {
            return INITIAL_STATE;
        }

        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/membershipsReducer.js
 **/